import { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  Dialog as MuiDialog,
  DialogActions as MuiDialogActions,
  Button as MuiButton,
  ListItemText as MuiListItemText,
  Divider as MuiDivider,
  DialogTitle as MuiDialogTitle,
  DialogContent as MuiDialogContent,
  List as MuiList,
  ListItem as MuiListItem,
  Typography as MuiTypography,
  Grid as MuiGrid,
} from "@mui/material";
import { Warning as MuiWarningIcon } from "@mui/icons-material";
import PropTypes from "prop-types";
import { renderContentBySplitingOnFullStop } from "../../utils";
import { errorDialogStyles } from "app/shared/UI/Dialog/ErrorDialogStyles";
import { LOADER_TYPES } from "app/shared/constants";
import { Loader } from "app/shared/UI/Loader";

const ErrorDialog = ({
  onClose,
  open,
  errorsList,
  title,
  primarySubHeading,
  secondarySubHeading,
  primaryContent,
  secondaryContent,
  displayDynamicPrimarySubHeading,
  isLoading,
}) => {
  const [scroll] = useState("paper");
  const { t } = useTranslation();

  return (
    <MuiDialog open={open} onClose={onClose} scroll={scroll}>
      <MuiDialogTitle
        id="error-dialog-title"
        sx={errorDialogStyles.errorSummaryTitle}
      >
        <MuiWarningIcon sx={errorDialogStyles.warning} fontSize="small" />
        {title}
      </MuiDialogTitle>
      <MuiDialogContent sx={errorDialogStyles.errorSummaryContent}>
        <MuiList>
          {isLoading[LOADER_TYPES.OUTREACH_FAILURE_SUMMARY] ||
          isLoading[LOADER_TYPES.STUDY_DASHBOARD_DATA] ? (
            <MuiGrid container justifyContent="center" alignItems="center">
              <Loader />
            </MuiGrid>
          ) : (
            errorsList.map((content, index) => {
              return (
                <div key={index}>
                  {index > 0 && <MuiDivider component="li" />}
                  <MuiListItem
                    alignItems="flex-start"
                    sx={errorDialogStyles.contentListItem}
                  >
                    <MuiListItemText
                      primary={
                        <span style={errorDialogStyles.itemTextBlock}>
                          {displayDynamicPrimarySubHeading ? (
                            <span style={errorDialogStyles.itemTextSpan}>
                              {content.type}
                            </span>
                          ) : (
                            primarySubHeading && (
                              <span style={errorDialogStyles.itemTextSpan}>
                                {primarySubHeading}
                              </span>
                            )
                          )}
                          <MuiTypography
                            variant="body1"
                            sx={errorDialogStyles.MuiTypography}
                          >
                            {content[primaryContent]}
                          </MuiTypography>
                        </span>
                      }
                      secondary={
                        <span
                          component="span"
                          style={errorDialogStyles.itemTextBlock}
                        >
                          {secondarySubHeading && (
                            <span style={errorDialogStyles.itemTextSpan}>
                              {secondarySubHeading}
                            </span>
                          )}
                          <MuiTypography
                            component="span"
                            sx={errorDialogStyles.MuiTypography}
                          >
                            {renderContentBySplitingOnFullStop(
                              content[secondaryContent]
                            )}
                          </MuiTypography>
                        </span>
                      }
                    />
                  </MuiListItem>
                </div>
              );
            })
          )}
        </MuiList>
      </MuiDialogContent>
      <MuiDialogActions>
        <MuiButton onClick={onClose} color="primary">
          {t(`Close`)}
        </MuiButton>
      </MuiDialogActions>
    </MuiDialog>
  );
};

ErrorDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
};

export default ErrorDialog;
